import React from 'react';

import { Form, Grid, Tooltip } from '@mairistem/composants';

import { Section } from '@/components/Common';

interface LieuSaisieProps {
  adressePacs: any;
  errors?: Record<string, string>;
  onChange: (
    _e: any,
    data: { name: string; value?: any; checked?: boolean },
  ) => void;
}

const LieuSaisie = (props: LieuSaisieProps) => {
  const { adressePacs, errors, onChange } = props;

  const baseName = 'conventionDeclaration.adressePacs';

  const handleAdresseChange = React.useCallback(
    (field: string, value: string) => {
      onChange(null, {
        name: `${baseName}.${field}`,
        value,
      });
    },
    [onChange],
  );

  const handleCheckboxChange = React.useCallback(
    (field: string, checked: boolean) => {
      onChange(null, {
        name: `${baseName}.${field}`,
        value: checked,
      });

      if (!checked) {
        onChange(null, {
          name: `${baseName}.libelleCommuneDelegue`,
          value: '',
        });
      }
    },
    [onChange],
  );

  return (
    <Section
      data-testid="assistant-lieu-saisie"
      title="LIEU DE SAISIE"
      style={{ minHeight: 'fit-content' }}
    >
      <Form>
        <Grid padded>
          <Grid.Row>
            <Grid.Column width={4}>
              <Form.Input
                label="&nbsp;"
                placeholder="CP / Cedex"
                input={{ 'data-testid': 'assistant-lieu-saisie-code-postal' }}
                value={adressePacs?.codePostal ?? ''}
                onChange={(_e, data) =>
                  handleAdresseChange('codePostal', data?.value ?? '')
                }
              />
            </Grid.Column>
            <Grid.Column width={3}>
              <Form.Input
                label="&nbsp;"
                placeholder="Art."
                input={{
                  'data-testid': 'assistant-lieu-saisie-article-localite',
                }}
                value={adressePacs?.articleLocalite ?? ''}
                onChange={(_e, data) =>
                  handleAdresseChange('articleLocalite', data?.value ?? '')
                }
              />
            </Grid.Column>
            <Grid.Column width={9}>
              <Form.Input
                label="&nbsp;"
                placeholder="Bureau Distributeur"
                input={{ 'data-testid': 'assistant-lieu-saisie-localite' }}
                value={adressePacs?.localite ?? ''}
                onChange={(_e, data) =>
                  handleAdresseChange('localite', data?.value ?? '')
                }
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ paddingTop: 0 }} verticalAlign="middle">
            <Grid.Column width={6}>
              <label>&nbsp;</label>
              <Form.Checkbox
                label="Commune déléguée"
                data-testid="assistant-lieu-saisie-commune-delegue"
                checked={adressePacs?.communeDelegue}
                onChange={(_e, data) =>
                  handleCheckboxChange('communeDelegue', data?.checked)
                }
              />
            </Grid.Column>
            <Grid.Column width={10}>
              <Tooltip
                trigger={
                  <div>
                    <Form.Input
                      label="&nbsp;"
                      input={{
                        'data-testid':
                          'assistant-lieu-saisie-libelle-commune-delegue',
                      }}
                      value={adressePacs?.libelleCommuneDelegue ?? ''}
                      disabled={!adressePacs?.communeDelegue}
                      error={!!errors?.libelleCommuneDelegue}
                      onChange={(_e, data) =>
                        handleAdresseChange(
                          'libelleCommuneDelegue',
                          data?.value ?? '',
                        )
                      }
                    />
                  </div>
                }
                type={errors?.libelleCommuneDelegue ? 'error' : ''}
                message={errors?.libelleCommuneDelegue}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </Section>
  );
};

export default LieuSaisie;
